<script>
import humps from 'humps'
import { CATEGORY_ICON_LIST, FUNCTION_LIST } from '@/components/pc/radio/ipradio/config/BCconstants.js'
import { CSS_COLORS } from '@/components/pc/radio/ipradio/config/css-constants'

export default {
  name: 'BCKeyAssignmentMenu',
  props: {
    setting: {
      type: Object,
      required: true,
    },
    keyType: {
      type: String,
      default: 'menu',
    },
  },
  data() {
    return {
      selectedCategoryIdx: 0,
      CATEGORY_ICON_LIST,
      FUNCTION_LIST,
      CSS_COLORS,
    }
  },
  computed: {
    menuKey() {
      return humps.pascalize(this.keyType)
    },
    categoryList() {
      const keyAssign = this.setting && this.setting.KeyAssignment
      return keyAssign ? keyAssign[this.menuKey] : []
    },
    functionList() {
      const cat = this.categoryList && this.categoryList[this.selectedCategoryIdx]
      const funcArr = cat && cat.Function ? cat.Function : []
      return funcArr.map((item) => {
        const found = this.FUNCTION_LIST.find((func) => func.value === item)
        return { label: found ? found.label : '' }
      })
    },
  },
  methods: {
    handleClickCategory(row, idx) {
      // eslint-disable-next-line no-console
      console.log('カテゴリークリック', row, idx)
      this.selectedCategoryIdx = idx
    },
  },
}
</script>

<template>
    <div class="menuSettingsWrapper">
        <el-table class="categoryTable" :data="categoryList">
            <el-table-column prop="Category" label="カテゴリー・リスト">
                <template #default="{ row, $index }">
                    <div
                        class="categoryItem"
                        :class="{ selected: selectedCategoryIdx === $index }"
                        :style="selectedCategoryIdx === $index ? { backgroundColor: CSS_COLORS.GRAYSCALE4 } : null"
                        @click="handleClickCategory(row, $index)"
                    >
                        <img
                            :src="(CATEGORY_ICON_LIST.find(icon => icon.value === row.Icon) || {}).label"
                            alt="icon"
                            style="width: 1.5em; height: 1.5em"
                        />
                        <span>{{ row.Category }}</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-table class="functionTable" :data="functionList">
            <el-table-column prop="label" label="機能リスト" />
        </el-table>
    </div>
</template>

<style scoped>
.menuSettingsWrapper {
    display: grid;
    grid-template-rows: auto 1fr;
    height: calc(100vh - 157px); /* ヘッダーやツールバーの高さを引いた値 */
    overflow: hidden;
}

.categoryTable {
    display: block;
    height: auto;
    min-height: calc((100vh - 157px) / 3); /* 初期表示は1/3 */
    max-height: calc((100vh - 157px) / 2); /* 最大は1/2 */
    overflow-y: auto;
}

.categoryItem {
    display: flex;
    gap: 0.5em;
    align-items: center;
}

/* Background for selected is applied inline via :style to ensure Vue 2 compatibility */

.functionTable {
    display: block;
    height: auto;
    overflow-y: auto;
}
</style>
